import { Navigate, Route } from "react-router-dom";
import { UserRole } from "../utils";
import DashboardLayout from "../pages/dashboard/elements/DashboardLayout";
import ManageUsers from "../pages/user-management/components/ManageUsers";
import AllUsers from "../pages/user-management/components/AllUsers";
import AddUser from "../pages/user-management/components/AddUser";
import UserDetails from "../pages/user-management/components/UserDetails";
import UserEdit from "../pages/user-management/components/UserEdit";
import UpdatePassword from "../pages/authentication/components/UpdatePassword";
import UpdateProfile from "../pages/user-management/components/UpdateProfile";
import ClientDetails from "../pages/client-management/components/ClientDetails";
import ListOfClients from "../pages/client-management/components/ListOfClients";
import UserRequests from "../pages/user-management/components/UserRequests";
import JobsCreate from "../pages/jobs-management/components/JobsCreate";
import JobDetails from "../pages/jobs-management/components/JobDetails";
import ListOfJobs from "../pages/jobs-management/components/ListOfJobs";
import JobEdit from "../pages/jobs-management/components/JobEdit";
import ClientEdit from "../pages/client-management/components/ClientEdit";
import UserProfile from "../pages/user-profile/components/UserProfile";
import HotLeads from "../pages/leads-management/pages/HotLeads/HotLeads";
import WarmLeads from "../pages/leads-management/pages/WarmLeads/WarmLeads";
import InterestedLeads from "../pages/leads-management/pages/InterestedLeads/InterestedLeads";
import NewLead from "../pages/leads-management/pages/NewLead/NewLead";
import AllLeads from "../pages/leads-management/pages/AllLeads/AllLeads";
import LeadDetails from "../pages/leads-management/pages/LeadDetails/LeadDetails";
import EditUserProfile from "../pages/user-profile/components/EditUserProfile";
import OperatorDashboardLayout from "../pages/dashboard/elements/OperatorDashboardLayout";
import ListOfOperators from "../pages/operator-management/components/ListOfOperators";
import OperatorPerformanceDetails from "../pages/operator-management/components/OperatorPerfomanceDetails";
import ListOfOrganisations from "../pages/organisation-management/components/ListOfOrganisations";
import AddOrganisation from "../pages/organisation-management/components/AddOrganisation";
import OrganisationDetails from "../pages/organisation-management/components/OrganisationDetails";

// Users of a deactivated organisation can only reach their own profile.
export const getRoutesForInactiveOrganisation = () => (
  <>
    <Route path="/user-profile" element={<UserProfile />} />
    <Route path="/user-profile/edit/:id" element={<EditUserProfile />} />
    <Route path="*" element={<Navigate to="/user-profile" replace />} />
  </>
);

export const getRoutesForRole = (role: UserRole) => {
  switch (role) {
    case UserRole.GlobalAdmin:
    case UserRole.Administrator:
      return (
        <>
          {(role === UserRole.GlobalAdmin) && (
            <>
              <Route path="/organisations" element={<ListOfOrganisations />} />
              <Route
                path="/organisations/add-organisation"
                element={<AddOrganisation />}
              />
              <Route
                path="/organisations/edit/:id"
                element={<AddOrganisation />}
              />
              <Route
                path="/organisations/:id"
                element={<OrganisationDetails />}
              />
            </>
          )}
          <Route path="/" element={<DashboardLayout />} />
          <Route path="leads/new-lead" element={<NewLead />} />
          <Route path="leads/all-leads" element={<AllLeads />} />
          <Route path="leads/hot-leads" element={<HotLeads />} />
          <Route path="leads/warm-leads" element={<WarmLeads />} />
          <Route path="leads/interested-leads" element={<InterestedLeads />} />
          <Route path="leads/all-leads/:id" element={<LeadDetails />} />
          <Route path="leads/hot-leads/:id" element={<LeadDetails />} />
          <Route path="/leads/interested-leads/:id" element={<LeadDetails />} />
          <Route path="leads/warm-leads/:id" element={<LeadDetails />} />

          <Route path="/user" element={<ManageUsers />} />
          <Route path="/user/users" element={<ManageUsers />} />
          <Route path="/user/requests" element={<UserRequests />} />
          <Route path="/user/all-users" element={<AllUsers />} />
          <Route path="/user/add-user" element={<AddUser />} />
          <Route
            path="/user/users/view-profile/:id"
            element={<UserDetails />}
          />
          <Route
            path="/user/requests/view-profile/:id"
            element={<UserDetails />}
          />
          <Route path="/user/users/edit/:id" element={<UserEdit />} />
          <Route path="/user/requests/edit/:id" element={<UserEdit />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/user-profile/edit/:id" element={<EditUserProfile />} />
          <Route path="/update-profile" element={<UpdateProfile />} />
          <Route path="/customers" element={<ListOfClients />} />
          <Route path="/customers/:id" element={<ClientDetails />} />
          <Route path="/customers/edit/:id" element={<ClientEdit />} />
          <Route path="/jobs" element={<ListOfJobs />} />
          <Route path="/jobs/add-job" element={<JobsCreate />} />
          <Route path="/jobs/:id" element={<JobDetails />} />
          <Route path="/jobs/edit/:id" element={<JobEdit />} />
          <Route path="/operators" element={<ListOfOperators />} />
          <Route path="/operators/:id" element={< OperatorPerformanceDetails />} />
        </>
      );

    case UserRole.Customer:
      return (
        <>
          <Route path="/" element={<DashboardLayout />} />
          <Route path="leads/hot-leads" element={<HotLeads />} />
          <Route path="leads/warm-leads" element={<WarmLeads />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/user-profile/edit/:id" element={<EditUserProfile />} />
          <Route path="leads/interested-leads" element={<InterestedLeads />} />
          <Route path="leads/all-leads" element={<AllLeads />} />
          <Route path="leads/all-leads/:id" element={<LeadDetails />} />
          <Route path="/leads/interested-leads/:id" element={<LeadDetails />} />
          <Route path="leads/warm-leads/:id" element={<LeadDetails />} />
          <Route path="leads/hot-leads/:id" element={<LeadDetails />} />
        </>
      );

    case UserRole.Operator:
      return (
        <>
          <Route path="/" element={<OperatorDashboardLayout />} />
          <Route path="leads/new-lead" element={<NewLead />} />;
          <Route path="leads/all-leads" element={<AllLeads />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/user-profile/edit/:id" element={<EditUserProfile />} />
          <Route path="leads/all-leads/:id" element={<LeadDetails />} />
        </>
      );

    default:
      return null;
  }
};
